<div class="card" >
    <div class="card-header" id="headingTheme{{topic.id}}">
      <h5 class="mb-0">
  		<a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
         {{topic.name}}
        </a>

        </h5>
    </div>
    <div id="collapseTheme{{topic.id}}" class="collapse {{myCount==0?'show':''}}"  data-parent="#accordionSubjThemes">
      <div class="card-body">
        <table class="table table-sm table-stripped table-hover table-responsive-sm">
            <tr *ngFor="let subtopic of topic.subtopics; index as ii">
              <td>
                 <i class="fa fa-angle-right text-primary"></i> {{ subtopic.name }}
              </td>
            </tr>
        </table>

      </div>
    </div>

</div>
